import alt from '../alt';
import {LoadAction} from '../actions';

class UnWrappedLoadStore {
  /**
   * @constructor
   */
  constructor() {
    this.processes = 0;
    this.appStarted = false;
    this.bindActions(LoadAction);
  }
  /**
   * @return {Boolean} If there is any process loading
   */
  static isLoading() {
    return this.getState().processes > 0;
  }
  /**
   * Notify that a process is loading
   */
  onAddProcess() {
    ++this.processes;
  }
  /**
   * Notify that a process stop loading
   */
  onRemoveProcess() {
    --this.processes;
  }
  /**
   * App started
   */
  onStartApp() {
    this.appStarted = true;
  }
}

export default alt.createStore(UnWrappedLoadStore, 'LoadStore');
